import {useSignal} from '@preact/signals-react'
import {forwardRef, useImperativeHandle} from 'react'
import './style/toggle-witches.css'
const CustomToggleWitches = forwardRef(
    (
        {
            defaultValue = false,
            label = 'One Time Reminder ?',
            onChange = () => {},
        },
        ref,
    ) => {
        const isChecked = useSignal(defaultValue)
        useImperativeHandle(ref, () => ({
            setValue: e => (isChecked.value = e),
        }))

        const handleToggle = () => {
            let value = !isChecked.value
            isChecked.value = value
            onChange(value)
        }

        return (
            <div className="flex justify-content-between gap-2 w-full">
                <div>
                    <h6 className="m-0 p-0 font-bold">{label}</h6>
                </div>

                <div className="toggle-button-cover">
                    <div className="button r" id="custom-toggle-button">
                        <input
                            checked={isChecked.value}
                            onChange={handleToggle}
                            type="checkbox"
                            className="checkbox"
                        />
                        <div className="knobs"></div>
                        <div className="layer"></div>
                    </div>
                </div>
            </div>
        )
    },
)

export default CustomToggleWitches
